import * as React from 'react';
import InputText from './InputText';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const InputTextWithAddon = props => {
  const {
    leftAddon,
    rightAddon,
    ...extraProps
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "InputGroup",
    children: [
    // $FlowFixMe[sketchy-null-string]
    leftAddon && /*#__PURE__*/_jsx("span", {
      className: "InputGroup-addon",
      children: leftAddon
    }), /*#__PURE__*/_jsx(InputText, {
      ...extraProps,
      className: "InputGroup-input InputGroup-input--block"
    }),
    // $FlowFixMe[sketchy-null-string]
    rightAddon && /*#__PURE__*/_jsx("span", {
      className: "InputGroup-addon",
      children: rightAddon
    })]
  });
};
export default InputTextWithAddon;